import React, { FC, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  IconButton,
  Typography,
  Stack,
  Box,
  FormControlLabel,
} from '@mui/material';
import { Icon } from '@iconify/react';
import { Button, TextField, Checkbox } from '../../components';
import { ISavedFilter } from '../../types';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  filter: Partial<ISavedFilter>;
  setFilter: (filter: Partial<ISavedFilter>) => void;
  handleFilterSave: (name: string, isDefault: boolean, isPublic: boolean, id?: string) => void;
  isEdit?: boolean;
};

const FilterSaveOrEditDialog: FC<Props> = ({ open, onClose, filter, setFilter, handleFilterSave, isEdit = false }) => {
  const onFilterSave = (name?: string, isDefault?: boolean, isPublic?: boolean, id?: string) => {
    if (!name) return;
    handleFilterSave(name, !!isDefault, !!isPublic, id);
  };
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography> {isEdit ? 'Edit Filter' : 'Add Filter'} </Typography>
          <Box>
            <IconButton size="small">
              <Icon onClick={onClose} icon="ei:close" />
            </IconButton>
          </Box>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ minWidth: 420 }}>
        <InputLabel
          htmlFor="input-with-text"
          sx={{ fontSize: '12px', fontWeight: '400', color: '#000', paddingBottom: '4px' }}
        >
          Name
        </InputLabel>
        <TextField
          type="email"
          placeholder="Configuration"
          sx={{ fontSize: 12, height: 36 }}
          value={filter.name}
          onChange={(e) => setFilter({ ...filter, name: e.currentTarget.value })}
        />
        <Box px={2} py={1}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={filter.isDefault}
                onChange={() => setFilter({ ...filter, isDefault: !filter.isDefault })}
              />
            }
            label="Make Default"
          />
        </Box>
        <Box px={2} pb={1}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={filter.isPublic}
                onChange={() => setFilter({ ...filter, isPublic: !filter.isPublic })}
              />
            }
            label="Make Public"
          />
        </Box>

        <DialogActions sx={{ mt: 2 }}>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={() => onFilterSave(filter.name, filter.isDefault, filter.isPublic, filter._id)}
            variant="contained"
          >
            {isEdit ? 'Update' : 'Save'}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default FilterSaveOrEditDialog;
